import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NewVersionBannerComponent } from './core/new-version/new-version-banner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NewVersionBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('frontend');
}
